import {
HIDE_EVENTS_LOADER, SHOW_EVENTS_LOADER, SET_EVENTS
} from "./actionTypes";

const INIT_STATE = {
  events: [],
  loading_events: false,
  // success: null,
  error: null,
};

const Events = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_EVENTS:
      return {
        ...state,
        events: action.payload
      }
    case SHOW_EVENTS_LOADER:
      return {
        ...state,
        loading_events: true
      }
    case HIDE_EVENTS_LOADER:
      return {
        ...state,
        loading_events: false
      }
    default:
      return state;
  }
};

export default Events;
